const numberRoundTo = ({ number, roundTo }) => +(Math.round(number + "e+" + roundTo)  + "e-" + roundTo);

export default {
  numberRoundTo,
};
